import React, { Component } from "react";
import API from "../../apiService.js";
import CurrencyFormat from "react-currency-format";
import PrintButton from "../lab/PrintButton.js";
import Alert from "../component/Alert";
import AlertWithButton from "../component/Alert";

export default class PermintaanLab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reg_lab_id: [],
      labs: [],
      visits: [],
      lab: [],
      button: true,
      detail: [],
      sample: "",
      is_ranap: window.location.pathname.includes("ranap"),
      inpatient: props.detilPx.inpatient ?? null,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.getServing();
  }

  onReload = () => {
    this.props.history.push("/pelayanan");
  };

  handleClick = (e, l) => {
    var k = this.state.detail;
    var j = [];
    if (k[e.target.value].checked) {
      k[e.target.value].checked = false;
      this.state.lab.map((x, n) => {
        j[n] = x;
        if (k[e.target.value].lab_group_id == x.id) {
          j[n].checked = false;
        }
      });
      this.setState({
        lab: j,
      });
    } else {
      k[e.target.value].checked = true;
      k[e.target.value]._cat = l;
    }

    this.setState({
      detail: k,
    });
  };

  handleChange = (e, l) => {
    var k = this.state.lab;
    var s = [];

    if (k[e.target.value].checked) {
      k[e.target.value].checked = false;
      this.state.detail.map((x, n) => {
        s[n] = x;
        if (x.lab_group_id == k[e.target.value].id && !x.disabled) {
          s[n].checked = false;
        }
      });
    } else {
      k[e.target.value].checked = true;
      this.state.detail.map((x, n) => {
        s[n] = x;
        if (x.lab_group_id == k[e.target.value].id) {
          s[n].checked = true;
          s[n]._cat = l;
        }
      });
    }

    this.setState({
      lab: k,
    });
  };

  getServing = async () => {
    try {
      var res = await API.get(
        "registration/lab/read?visit_id=" + this.props.detilPx.id
      );
      if (res.code == 200) {
        this.setState({
          reg_lab_id: res.data[0].id,
          labs: res.data[0].details,
          visits: res.data[0].visit,
          sample: res.data[0].sample,
        });
      }
    } catch (error) {}
    try {
      //  }etAllLab = async () => {
      var res2 = await API.get("management/lab_group/read");

      if (res2.code == 200) {
        let group = [];
        let lab = [];

        let d = 0;
        res2.data.map((x, n) => {
          group[n] = x;
          if (
            this.state.labs.find((set) => set.lab_group_id == x.id) &&
            !this.state.is_ranap
          ) {
            group[n].checked = true;
            group[n].disabled = false;
          } else {
            group[n].checked = false;
            group[n].disabled = false;
          }

          x.details.map((detail) => {
            lab[d] = detail;
            if (
              this.state.labs.find(
                (set) => !set.log && set.lab_id == detail.lab_id
              ) &&
              !this.state.is_ranap
            ) {
              lab[d].checked = true;
              lab[d].disabled = true;
            } else {
              lab[d].checked = false;
              lab[d].disabled = false;
            }
            lab[d].group_id = x.id;

            d++;
          });
        });

        this.setState({
          lab: group,
          detail: lab,
        });
      }
    } catch (error) {}
  };

  handleSend = async () => {
    this.setState({ button: false });
    var k = [];
    var i = 0;
    var h;
    this.state.detail.map((x) => {
      if (x.checked && !x.disabled) {
        k[i] = x;
        h = this.state.labs.find((set) => !set.log && set.lab_id == x.lab_id);
        if (h) k[i].id = h.id;
        else k[i].id = null;
        // k[i].result = 0;
        k[i].disabled = true;

        if (
          this.state.lab.find((set) => set.checked && set.id == x.lab_group_id)
        )
          k[i].lab_group_id = x.lab_group_id;
        else k[i].lab_group_id = null;
        i++;
      }
    });

    const res = await API.put("registration/lab/update", {
      lab: [
        {
          id: this.state.labs[0] ? this.state.labs[0].registration_lab_id : "",
          visit_id: this.props.detilPx.id,
          visit_inpatient_clinic_id: this.state.is_ranap
            ? this.state.inpatient.id
            : null,
          sample: this.state.sample,
          details: k,
        },
      ],
      is_ranap: this.state.is_ranap,
    });
    if (res.code == 200) {
      Alert(
        "success",
        "Sukses menyimpan data permintaan pemeriksaan lab pasien"
      );

      this.setState({
        labs: res.data[0] ? res.data[0].details : [],
        visits: res.data[0] ? res.data[0].visit : [],
        reg_lab_id: res.data[0] ? res.data[0].id : 0,
      });
    } else {
      AlertWithButton(
        "warning",
        "Gagal menyimpan data permintaan pemeriksaan lab pasien\nPeriksa kembali isian data anda"
      );
    }
    this.setState({ button: true });
  };

  render() {
    return (
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <div className="row align-items-center">
                <div className="col-8">
                  <h4 className="h3 mb-0">
                    Permintaan Pemeriksaan Laboratorium
                  </h4>
                </div>
                <div className="col-4 d-flex justify-content-end">
                  <PrintButton
                    url={`/registration/lab/print_permintaan/${this.state.reg_lab_id}`}
                    buttonText="Cetak Permintaan Lab"
                  />
                  {this.state.visits.labs_flags ? (
                    <PrintButton
                      url={`/apm/queues/print?visit_id=${this.props.detilPx.id}`}
                      buttonText="Cetak Nomor Antrian"
                    />
                  ) : (
                    <div></div>
                  )}
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="accordion" id="accordionlab">
                {this.state.lab.map((lab, keys) => {
                  let color = this.state.detail.find(
                    (set) => set.checked && set.group_id == lab.id
                  )
                    ? "#5e72e4"
                    : "";
                  return (
                    <>
                      {this.state.lab[keys - 1] ? (
                        this.state.lab[keys].details[0].lab.category.name !=
                        this.state.lab[keys - 1].details[0].lab.category
                          .name ? (
                          <div className="bg-gray p-2 text-white">
                            {lab.details[0].lab.category?.name}
                          </div>
                        ) : (
                          ""
                        )
                      ) : (
                        <div className="bg-gray p-2 text-white">
                          {this.state.lab[keys].details[0].lab.category?.name}
                        </div>
                      )}

                      <div key={keys} className="card">
                        <div
                          className="card-header collapsed"
                          id={"headinglab" + lab.id}
                          data-toggle="collapse"
                          data-target={"#collapselab" + lab.id}
                          aria-expanded="false"
                          aria-controls={"collapselab" + lab.id}
                        >
                          <div
                            style={{ color: this.state.is_ranap ? "" : color }}
                            className="h4"
                          >
                            {lab.name.toUpperCase() + " "}
                          </div>
                        </div>

                        <div
                          className="collapse"
                          id={"collapselab" + lab.id}
                          aria-labelledby={"headinglab" + lab.id}
                        >
                          <div className="card-body">
                            <div className="row">
                              <div className="col-12">
                                Harga Paket {lab.name}{" "}
                                <CurrencyFormat
                                  value={lab.price}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"Rp "}
                                  renderText={(value) => (
                                    <mark className="h5">{value}</mark>
                                  )}
                                />
                                <label
                                  style={{ float: "right" }}
                                  className="badge badge-primary badge-pill"
                                >
                                  <input
                                    className="custom-checkbox"
                                    id={"chk-lab-task" + lab.id}
                                    type="checkbox"
                                    checked={lab.checked}
                                    disabled={lab.disabled}
                                    value={keys}
                                    onChange={(e) => this.handleChange(e, lab.id)}
                                  />{" "}
                                  Pilih Semua
                                </label>
                              </div>
                              {this.state.detail.map((detail, key) => {
                                return detail.group_id == lab.id ? (
                                  <div key={key} className="col-md-6">
                                    <label
                                      style={{
                                        paddingBottom: "5Px",
                                        paddingTop: "2Px",
                                      }}
                                      className="list-group-item checklist-item checklist-item-primary"
                                    >
                                      <div>
                                        {detail.lab ? detail.lab.name : ""}
                                        <br></br>
                                        <CurrencyFormat
                                          value={detail.price}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          prefix={"Rp "}
                                          renderText={(value) => (
                                            <mark className="h5">{value}</mark>
                                          )}
                                        />
                                      </div>
                                      <input
                                        className="custom-checkbox-success"
                                        style={{ float: "right" }}
                                        name={
                                          "chk-lab-detail" + detail.group_id
                                        }
                                        type="checkbox"
                                        checked={detail.checked}
                                        value={key}
                                        disabled={detail.disabled}
                                        onChange={(e) =>
                                          this.handleClick(e, lab.id)
                                        }
                                      />
                                    </label>
                                    {/* <div className="custom-control custom-checkbox custom-checkbox-success">
                                        <input type="checkbox" className="custom-control-input" name="chk-lab-detail[]" id={'chk-lab-detail-' + detail.id} />
                                        <label className="custom-control-label" for={'chk-lab-detail-' + detail.id}></label>
                                      </div> */}
                                    <br></br>
                                  </div>
                                ) : (
                                  ""
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
              <button
                disabled={this.state.button ? "" : "disabled"}
                className="btn btn-primary"
                onClick={this.handleSend}
              >
                {this.state.button ? "Simpan Permintaan" : "Menyimpan Data..."}
              </button>
              <button className="btn btn-danger" onClick={this.onReload}>
                Tutup
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
